import { Component } from '@angular/core';

@Component({
  selector: 'wp-page-title',
  standalone: true,
  templateUrl: './page-title.component.html',
  styleUrl: './page-title.component.scss',
})
export class PageTitleComponent {}
